export const PermissionNotice = {
  PUT: "change_notice",
  POST: "add_notice",
  VIEW: "view_notice",
  DELETE: "delete_notice",
  EXPORT: "can_export_notice",
};